import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ element }) => {
  let { user } = useAuth();
  user = "client";
  return user ? element : <Navigate to="/login" />;
};

export default ProtectedRoute;
